import React, { Component } from "react";
import { Container } from "react-bootstrap";
import { Trans } from "react-i18next";

class OtherProjects extends Component {
  render() {
    return (
      <Container>
        <div className="services-content row">
          <p>OtherProjects</p>
        </div>
      </Container>
    );
  }
}

export default OtherProjects;
